import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { STANDARD_FOUR_TIME_ZONE_ID, UtilityService } from '@eforall/common';
import { GridContentWidget } from '@eforall/dashboard';
import { AppService } from '../../../../../../services';
import { SpecialistSignUpViewerDialogDataService } from '../specialist-sign-up-viewer-dialog-data.service';
import { getSetup } from './grid/get-setup';
@Component({
	selector: 'specialist-sign-up-events-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './events.part.html',
})
export class SpecialistSignUpEventsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	private readonly service = inject(SpecialistSignUpViewerDialogDataService);
	private readonly appService = inject(AppService);

	// subtracting (70 + 85) to account for padding, tabstrip and timeZone details, and 50 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 155 - (this.service.canEdit() ? 0 : 50));

	public readonly specialistSignUpDetails = computed(() => {
		const appData = this.appService.data();
		const details = this.service.specialistSignUpDetails();
		if (!details || !appData) return undefined;

		return {
			...details,
			volunteerTimeZoneName: details.standardFourTimeZoneId ? `${STANDARD_FOUR_TIME_ZONE_ID[details.standardFourTimeZoneId]} Time` : 'Not Provided',
			userTimeZoneName: `${STANDARD_FOUR_TIME_ZONE_ID[appData.standardLocalTimezoneId]} Time`,
		};
	});

	public readonly allEvents = computed(() => {
		return this.specialistSignUpDetails()?.topics || [];
	});

	public setup = getSetup(this.service, this.util);
}